import { Button, LayoutControls, Typography } from '@pinwheel/origami';
import React, { useCallback } from 'react';
import Dollar from '../../assets/Dollar';
import TitleFrame from '../../LinkApiRouter/components/TitleFrame';
import { useOpts } from '../../context';
import useSkipDepositConfirmation from '../../LinkApiRouter/hooks/useSkipDepositConfirmation';
import useAmountSelectionButtonText from '../../LinkApiRouter/hooks/useAmountSelectionButtonText';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
var formatDollarAmt = function (amt) {
    // regex for valid fractional amounts that need a 0 padded on the end, i.e. "55.5"
    return /^[0-9]*\.\d$/.test(String(amt)) ? "".concat(amt, "0") : amt;
};
export var getAmountFromToken = function (linkTokenPayload) {
    var incorrectlyTypedAmountFromToken = linkTokenPayload.amount, allocation = linkTokenPayload.allocation;
    // TODO (Octavio): Remove legacy "amount" as string. New allocation is Number (DD-86)
    var amount = incorrectlyTypedAmountFromToken;
    var amountFromToken = amount || (allocation === null || allocation === void 0 ? void 0 : allocation.value);
    return amountFromToken;
};
function AmountFromToken(props) {
    var getLocalizedString = useGetLocalizedString();
    var _a = useOpts(), linkTokenPayload = _a.linkTokenPayload, setAmountSelection = _a.setAmountSelection;
    var amountFromToken = getAmountFromToken(linkTokenPayload);
    var displayAmount = formatDollarAmt(amountFromToken);
    var goToNext = useCallback(function () {
        setAmountSelection === null || setAmountSelection === void 0 ? void 0 : setAmountSelection({
            action: 'partial_switch',
            allocation: { type: 'amount', value: amountFromToken },
        });
        props.onContinue();
    }, [amountFromToken, props, setAmountSelection]);
    useSkipDepositConfirmation(goToNext);
    var buttonText = useAmountSelectionButtonText();
    return (React.createElement(React.Fragment, null,
        React.createElement(TitleFrame, { title: getLocalizedString('REVIEW_DEPOSIT'), subtitle: getLocalizedString('YOU_CAN_CHANGE') },
            React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between' }, "data-testid": "AmountFromToken" },
                React.createElement(Typography, { sx: {
                        lineHeight: '24px',
                    } }, getLocalizedString('AMOUNT_PER_PAYCHECK')),
                React.createElement("div", { style: { display: 'flex' } },
                    React.createElement(Dollar, { size: 24, color: "#4D5E73" }),
                    React.createElement(Typography, { "data-testid": "provider-fixedAmount", sx: {
                            lineHeight: '24px',
                        } }, displayAmount)))),
        React.createElement(LayoutControls, null,
            React.createElement(Button, { eventId: "AmountSelection-continue", onClick: goToNext }, buttonText))));
}
export default AmountFromToken;
